import script from "./EditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorView.vue?vue&type=script&setup=true&lang=js"

import "./EditorView.vue?vue&type=style&index=0&id=ead468e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead468e4"]])

export default __exports__